import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import './UserInfoHeader.css';

/**
 * User Info Header Component
 * Displays user avatar, name, and dropdown menu
 * Pattern from LMS
 */
export default function UserInfoHeader() {
  const { user, logout, isSuperAdmin } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  if (!user) return null;

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getRoleColor = () => {
    return isSuperAdmin ? '#3bac75' : '#007bff';
  };

  return (
    <div className="user-info-header">
      <div 
        className="user-avatar-container"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div 
          className="user-avatar"
          style={{ backgroundColor: getRoleColor() }}
        >
          {getInitials(user.name)}
        </div>
        <div className="user-details">
          <div className="user-name">{user.name}</div>
          <div className="user-role">
            {isSuperAdmin ? 'Super Admin' : 'User'}
          </div>
        </div>
        <i className="las la-angle-down" />
      </div>

      {showDropdown && (
        <div className="user-dropdown">
          <div className="dropdown-item user-info">
            <div className="info-label">Email</div>
            <div className="info-value">{user.email}</div>
          </div>
          <div className="dropdown-item user-info">
            <div className="info-label">Role</div>
            <div className="info-value">{user.role}</div>
          </div>
          <div className="dropdown-divider" />
          <button 
            className="dropdown-item dropdown-button logout"
            onClick={logout}
          >
            <i className="las la-sign-out-alt" />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
}


